import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CheckIcon from '@material-ui/icons/Check'
import CircularProgress from '@material-ui/core/CircularProgress'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import Grid from '@material-ui/core/Grid'
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty'
import Typography from '@material-ui/core/Typography'

import { PENDING, REJECTED, RESOLVED } from './constants'

const useStyles = makeStyles(({ palette }) => ({
	icon: {
		position: 'relative',
		width: '48px',
	},
	fabProgress: {
		color: palette.secondary.main,
		position: 'absolute',
		top: -4,
		left: -4,
		zIndex: 1,
	},
}))

const statusIcons = {
	[RESOLVED]: { icon: CheckIcon, color: 'primary' },
	[PENDING]: { icon: HourglassEmptyIcon, color: 'disabled' },
	[REJECTED]: { icon: ErrorOutline, color: 'error' },
}

/**
 * Component to evaluate status and display messages
 */
export default function CircularIntegration({ status, error, message, externalError }) {
	const classes = useStyles()
	const Icon = statusIcons[status].icon

	return (
		<Grid container alignItems="center" direction="row" zeroMinWidth={true}>
			<Grid item className={classes.icon}>
				<Icon color={statusIcons[status].color} fontSize="large" />
				{status === PENDING && !externalError && <CircularProgress size={42} className={classes.fabProgress} />}
			</Grid>
			<Grid item>
				<Typography variant="subtitle1">{`${status} ${error ? error : message}`}</Typography>
			</Grid>
		</Grid>
	)
}
